import { MouseEvent } from "react";

import { BasicTooltip } from "@/components/ui/Tooltip";
import {
  getSignalBubbleClassName,
  type SidebarSignalBubble,
} from "@/routes/request-logs/search/signal-search-utils";

interface SignalBubbleButtonProps {
  signal: SidebarSignalBubble;
  active: boolean;
  onSignalClick: (event: MouseEvent<HTMLButtonElement>, signal: SidebarSignalBubble) => void;
}

const SignalBubbleButton = ({ signal, active, onSignalClick }: SignalBubbleButtonProps) => (
  <BasicTooltip content="Add Signal filter">
    <button
      type="button"
      className={`inline-flex cursor-pointer items-center whitespace-nowrap rounded-sm px-1.5 py-0.5 text-xs font-medium transition-opacity hover:opacity-80 ${getSignalBubbleClassName(active)}`}
      onMouseDown={event => event.stopPropagation()}
      onClick={event => onSignalClick(event, signal)}
    >
      {signal.name}
    </button>
  </BasicTooltip>
);

export default SignalBubbleButton;
